// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2W7-X","label":"Labeled_label__1sFli","divider":"Labeled_divider__C7nB-"};